import { Fragment, useState } from 'react';
import { SxProps } from '@mui/material';
import { TZDate } from '@repo/tzdate';
import DateTimePickerInput from './subcomponents/DateTimePickerInput';
import DateTimePickerPopover from './subcomponents/DateTimePickerPopover';

export const initialDateTimeState: TZDate | null = null;

export interface DateTimePickerProps {
    onChange(date: TZDate | null): void;
    value: TZDate | null;
    label: string;
    showError?: boolean;
    required?: boolean;
    labelColor?: string;
    minDate?: TZDate;
    variant?: 'filled' | 'outlined';
    sx?: SxProps;
    color?: string;
    backgroundColor?: string;
}

export default function DateTimePicker(props: DateTimePickerProps) {
    const {
        label,
        showError = false,
        required = false,
        labelColor,
        minDate,
        variant = 'filled',
        sx,
        color,
        backgroundColor,
        value,
        onChange,
    } = props;

    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | HTMLInputElement | null>(null);

    return (
        <Fragment>
            <DateTimePickerInput
                labelColor={labelColor}
                label={label}
                showError={showError}
                required={required}
                setAnchorEl={setAnchorEl}
                dateValue={value}
                variant={variant}
                sx={sx}
                textColor={color}
                backgroundColor={backgroundColor}
            />
            <DateTimePickerPopover
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                dateValue={value}
                minDate={minDate}
                onSelectDateTime={onChange}
            />
        </Fragment>
    );
}
